import {API_BASE_URL, STORAGE_KEYS} from '@/shared/config'

export interface StoredRecording {
  call_id: string
  room_id: string
  started_at: string
}

/**
 * Returns URL for downloading a recording.
 * Backend returns 307 redirect to a presigned S3 URL and long-polls until the file is ready.
 */
export function getRecordingDownloadUrl(callId: string): string {
  const base = API_BASE_URL.replace(/\/$/, '')
  return `${base}/recordings/${callId}/download`
}

const STORAGE_KEY = STORAGE_KEYS.RECORDINGS

function saveRecordings(recordings: StoredRecording[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(recordings))
}

export function saveRecording(entry: StoredRecording): void {
  const recordings = getRecordingsList()
  recordings.unshift(entry)
  saveRecordings(recordings)
}

export function getRecordingsList(): StoredRecording[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}
